<template>
  <div class="w-full flex justify-center pb-16 px-4 sm:px-8 mt-2">
    <div class="w-full max-w-4xl">
      
      <!-- HEADER (Strictly Left Aligned) -->
      <div class="flex flex-col mb-10 pb-6 border-b border-gray-100 text-left w-full items-start animate-fade-in">
        <h1 class="text-3xl sm:text-4xl font-extrabold text-gray-900 tracking-tight mb-3">
          {{ $t("trainingDuration.td1") }}
        </h1>
        <p class="text-gray-500 font-medium text-lg">{{ $t("trainingDuration.td2") }}</p>
      </div>

      <!-- FLAT PICKR POPUP FOR CUSTOM DATE -->
      <vs-popup
        class="holamundo items-center"
        :title="$t('TrainingDuration')"
        :active.sync="popupActive"
      >
        <div class="p-4 flex justify-center">
          <flat-pickr
            v-model="custom_duration"
            :config="{ inline: 'true', dateFormat: 'd F Y', minDate:new Date(new Date().setDate(new Date().getDate() + 6))}"
            class="w-full custom-flatpickr"
            name="trainingDuration"
          />
        </div>
      </vs-popup>

      <!-- DURATION SELECTION GRID -->
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 mb-8 animate-fade-in-up" style="animation-delay: 0.1s;">
        
        <!-- 1 MONTH -->
        <div 
          class="duration-card p-6 flex items-center justify-center cursor-pointer select-none transition-all duration-300 text-center font-bold text-lg border relative overflow-hidden"
          :class="td === 1 ? 'bg-primary border-primary text-white shadow-lg -translate-y-1' : 'bg-white border-gray-200 text-gray-600 hover:border-gray-300 hover:shadow-md hover:-translate-y-1'"
          @click="storeTrainingDuration(1)"
        >
          {{ $t("trainingDuration.td3") }}
        </div>

        <!-- 3 MONTHS -->
        <div 
          class="duration-card p-6 flex items-center justify-center cursor-pointer select-none transition-all duration-300 text-center font-bold text-lg border relative overflow-hidden"
          :class="td === 3 ? 'bg-primary border-primary text-white shadow-lg -translate-y-1' : 'bg-white border-gray-200 text-gray-600 hover:border-gray-300 hover:shadow-md hover:-translate-y-1'"
          @click="storeTrainingDuration(3)"
        >
          {{ $t("trainingDuration.td4") }}
        </div>

        <!-- 6 MONTHS -->
        <div 
          class="duration-card p-6 flex items-center justify-center cursor-pointer select-none transition-all duration-300 text-center font-bold text-lg border relative overflow-hidden"
          :class="td === 6 ? 'bg-primary border-primary text-white shadow-lg -translate-y-1' : 'bg-white border-gray-200 text-gray-600 hover:border-gray-300 hover:shadow-md hover:-translate-y-1'"
          @click="storeTrainingDuration(6)"
        >
          {{ $t("trainingDuration.td5") }}
        </div>

        <!-- 12 MONTHS -->
        <div 
          class="duration-card p-6 flex items-center justify-center cursor-pointer select-none transition-all duration-300 text-center font-bold text-lg border relative overflow-hidden"
          :class="td === 12 ? 'bg-primary border-primary text-white shadow-lg -translate-y-1' : 'bg-white border-gray-200 text-gray-600 hover:border-gray-300 hover:shadow-md hover:-translate-y-1'"
          @click="storeTrainingDuration(12)"
        >
          {{ $t("trainingDuration.td6") }}
        </div>

      </div>

      <!-- CUSTOM TIME BUTTON -->
      <div class="w-full animate-fade-in-up" style="animation-delay: 0.2s;">
        <div 
          class="duration-card w-full p-6 flex flex-col items-center justify-center cursor-pointer select-none transition-all duration-300 text-center relative overflow-hidden group"
          :class="td === 13 ? 'bg-primary border-primary border-2 text-white shadow-lg' : 'bg-gray-50 border-2 border-dashed border-gray-300 text-gray-600 hover:bg-primary/5 hover:border-primary/50 hover:text-primary'"
          @click="showCustomCalendar"
        >
          <span class="font-bold text-lg transition-colors duration-300 mb-1">
            {{ $t("trainingDuration.td7") }}
          </span>
          <!-- Shows selected custom date if one exists -->
          <span v-if="td === 13 && custom_duration" class="text-sm font-medium opacity-90 mt-1 bg-white/20 px-3 py-1 rounded-full">
            Target: {{ formatDate(custom_duration) }}
          </span>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import flatpickr from 'flatpickr'
import {Spanish} from "flatpickr/dist/l10n/es";
if(window.$cookies.get('locale') ==='es'){
  flatpickr.localize(Spanish);
}

import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  name: "TrainingDuration",
  data() {
    return {
      selected: null,
      td: null,
      training_duration: null,
      today: new Date(),
      custom_duration: null, 
      popupActive: false,
      disabled: true
    };
  },
  watch: {
    custom_duration: function(o, n) {
      this.storeCustomDuration(n);
    }
  },
  methods: {
    formatDate(createdAt) {
      if(createdAt === "" || createdAt === null) return null
      let date = new Date(createdAt)
      date = `${date.getDate()}-${date.getMonth()+1}-${date.getFullYear()}`;
      return date;
    },
    storeTrainingDuration(td) {
      this.td = td;
      const date = new Date();
      this.training_duration = new Date(
        date.setTime(date.getTime() + (td * 30 * 86400000+5*86400000))
      );
      this.disabled = false;
      
      this.$store
        .dispatch("addSkill/setTrainingDuration", this.training_duration)
        .then(res => {})
        .catch(err => { console.log("could not set training duration", err); });
    },
    showCustomCalendar() {
      this.td = 13;
      this.popupActive = true;
    },
    storeCustomDuration() {
      this.$store
        .dispatch("addSkill/setTrainingDuration", this.custom_duration)
        .then(res => {})
        .catch(err => { console.log("could not set training duration", err); });
    },
    stepBack() {
      this.$router.push({ name: "rate-your-level" });
    },
    stepForward() {
      this.saveSelectedCompetency();
      this.$router.push({ name: "progress-measure" });
    }
  },
  components: {
    Datepicker,
    flatPickr
  }
};
</script>

<style scoped>
/* Base Animations */
.animate-fade-in {
  animation: fadeIn 0.4s ease-out forwards;
  opacity: 0;
}
.animate-fade-in-up {
  animation: fadeInDown 0.5s cubic-bezier(0.25, 1, 0.5, 1) forwards;
  opacity: 0;
}

@keyframes fadeIn {
  0% { opacity: 0; }
  100% { opacity: 1; }
}
@keyframes fadeInDown {
  0% { opacity: 0; transform: translateY(15px); }
  100% { opacity: 1; transform: translateY(0); }
}

/* ------------------------------------- 
   CARD STYLING
   ------------------------------------- */
.duration-card {
  border-radius: 1.25rem !important; /* Soft pill-like rectangle */
}

/* Customizing Flatpickr slightly so it doesn't look completely unstyled inside the Vuesax popup */
.custom-flatpickr /deep/ .flatpickr-calendar {
  box-shadow: none !important;
  border: none !important;
}
</style>